<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"-->
      <!--&gt;</div>-->
      <svg class="icon" aria-hidden="true">
        <use
          :xlink:href="item.url === $route.path ? item.icon2 : item.icon1"
        ></use>
      </svg>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
		{
			name: "首页",
			icon1: "#icon-home",
			icon2: "#icon-home_selected",
			url: "/"
		},
		{
		  name: "精选",
		  icon1: "#icon-class",
		  icon2: "#icon-class_selected",
		  url: "/category"
		},
        {
          name: "附近社区",
          icon1: "#icon-select",
          icon2: "#icon-select_selected",
          url: "/shop/storeList"
        },
        {
          name: "购物车",
          icon1: "#icon-cart",
          icon2: "#icon-cart_selected",
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "#icon-my",
          icon2: "#icon-my_selected",
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
